import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { getExtendedStudentPersona } from "./api";

export const studentExtendedPersonaQueryKey = (id: string) => ["extendedPersona", id] as const;

export function studentExtendedPersonaQueryOptions(id: string) {
    return queryOptions({
        queryKey: studentExtendedPersonaQueryKey(id),
        queryFn: () => getExtendedStudentPersona(id),
        staleTime: 1 * 60 * 1000, // 1m
        gcTime: 60 * 60 * 1000, // keep cached for 1h
    });
}

export function useStudentExtendedPersona(id: string) {
    return useQuery(studentExtendedPersonaQueryOptions(id));
}

export function useStudentExtendedPersonaSuspense(id: string) {
    return useSuspenseQuery(studentExtendedPersonaQueryOptions(id));
}